<template>
  <section v-show="items.length" id="compareBar" data-open="compareRackRevealContainer" qaid="compareBar">
    <div class="compare-bar">
      <div class="compare-bar-counter-and-message" qaid="compareBarMessageContainer">
        <div class="compare-bar-counter" qaid="compareBarCounter" v-text="items.length"></div>
        <div class="compare-bar-message" qaid="compareBarMessage" v-text="compareBarMessage"></div>
      </div>
      <div class="compare-bar-add" qaid="compareBarAddButton">
        <i class="material-icons">add</i>
      </div>
    </div>
  </section>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';

export default {
  data() {
    return {
      debug: false,
      testIndex: 0,
      scrollTopLocation: null,
      compareProductCardHeight: 0,
      isIphone: navigator.platform.indexOf('iPhone') != -1,
      isSafari: navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1,
    };
  },

  computed: {
    compareBarMessage() {
      return this.items.length == 4 ? this.bp('fullRack') : this.bp('compareTitle');
    },

    isRackFull() {
      return this.items.length == 4;
    },

    compareHref() {
      return `${this.encodedContextPath}/compare/`;
    },

    items() {
      if (!Object.prototype.hasOwnProperty.call(this.racks, this.unitId)) return [];
      return this.racks[this.unitId];
    },

    ...mapState('backend', ['encodedContextPath']),
    ...mapState('compare', ['racks']),
    ...mapState(['b2bUnit']),
    ...mapGetters(['unitId']),
  },

  mounted() {
    this.createRack();
  },

  methods: {
    setProperRackHeightValue() {
      if (this.compareProductCardHeight <= 0) {
        // ignore if already set
        this.compareProductCardHeight = $('.compare-rack__product')
          .first()
          .height();
      }
    },

    ...mapActions('compare', ['addToRack', 'createRack', 'removeFromRack']),
  },
};
</script>
